<template>
    <div class="tags-view-container">
      <nx-scroll-pane class='tags-view-wrapper' ref='scrollPane'>
        <router-link ref='tag' class="tags-view-item" :class="isActive(tag)?'active':''" v-for="tag in Array.from(visitedViews)"
          :to="tag.path" :key="tag.path" @contextmenu.prevent.native="openMenu(tag,$event)">
          <!--{{generateTitle(tag.title)}}-->
          {{tag.title}}
          <span class='el-icon-close' @click.prevent.stop='closeSelectedTag(tag)'></span>
        </router-link>
      </nx-scroll-pane>
      <ul class='contextmenu' v-show="visible" :style="{left:left+'px',top:top+'px'}">
        <li @click="closeSelectedTag(selectedTag)">关闭</li>
        <li @click="closeOthersTags">关闭其他</li>
        <li @click="closeAllTags">关闭所有</li>
      </ul>
    </div>
  </template>
  
  <script>
  import nxScrollPane from './nxScrollPane'
  // import { generateTitle } from '@/utils/i18n'
  
  export default {
    name: 'tagsView',
    components: { nxScrollPane },
    data() {
      return {
        visible: false,
        top: 115,
        left: 0,
        selectedTag: {},
        homePath: ''
      }
    },
    computed: {
      visitedViews() {
        return this.$store.state.visitedViews
      }
    },
    watch: {
      $route() {
        this.addViewTags()
        this.moveToCurrentTag()
      },
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu)
        } else {
          document.body.removeEventListener('click', this.closeMenu)
        }
      }
    },
    mounted() {
      this.addViewTags()
      let menuList = localStorage.getItem('menuSettings') ? JSON.parse(localStorage.getItem('menuSettings')) : ''
      if (menuList && menuList.length > 0) {
        this.homePath = menuList[menuList.length - 1].sourceTreeDTOList[0].sourceTreeDTOList[0].code
      }
    },
    methods: {
      // generateTitle, // generateTitle by vue-i18n
      generateRoute() {
        if (this.$route.name) {
          return this.$route
        }
        return false
      },
      isActive(route) {
        return route.path === this.$route.path
      },
      addViewTags() {
        const route = this.generateRoute()
        if (!route) {
          return false
        }
        this.$store.dispatch('addVisitedViews', route)
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag.$el)
              break
            }
          }
        })
      },
      closeSelectedTag(view) {
        this.$store.dispatch('delVisitedViews', view).then((views) => {
          if (this.isActive(view)) {
            const latestView = views.slice(-1)[0]
            if (latestView) {
              this.$router.push(latestView.path)
            } else {
              this.$router.push(this.homePath)
            }
          }
        })
      },
      closeOthersTags() {
        this.$router.push(this.selectedTag.path)
        this.$store.dispatch('delOthersViews', this.selectedTag).then(() => {
          this.moveToCurrentTag()
        })
      },
      closeAllTags() {
        this.$store.dispatch('delAllViews')
        this.$router.push(this.homePath)
      },
      openMenu(tag, e) {
        this.visible = true
        this.selectedTag = tag
        this.left = e.clientX
        // this.top = e.clientY
      },
      closeMenu() {
        this.visible = false
      }
    }
  }
  </script>
  
  <style rel="stylesheet/less" lang="less" scoped>
    @import '../assets/css/variables.less';
    //sidebar
    @menuBg: #304156;
    @subMenuBg: #00946e;
    @menuHover: #008462;
    @blueBG: #212121;
    @hoverBG: #484848;
    @activeBG: #252525;
    @activeBG2: #263238;
    @hoverBG2: #263238;
    @sidebarWidth: 250px;
    @activeIndicator: #60ad5e;
  .tags-view-container {
    width: calc(100% - 20px);
    padding-left: 10px;
    padding-right: 10px;
    background: #edf1f5;
    .tags-view-wrapper {
      background: #fff;
      height: 40px;
      // border-bottom: 1px solid #E8EDEE;
      z-index: 1900;
      position: relative;
      /*margin-top: 50px;*/
      top: 0px;
      /*line-height: 34px;*/
      /*box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);*/
      .tags-view-item {
        display: inline-block;
        position: relative;
        height: 30px;
        line-height: 30px;
        border:1px solid #E8EDEE;
        color: #99999B;
        background: #fff;
        padding: 0 8px;
        font-size: 14px;
        margin-left: -1px;
        margin-top: 4px;
        border-radius:4px 4px 0px 0px;
        &:first-of-type {
          margin-left: 15px;
        }
        &.active {
          background-color: #ccc;
          /*background-color: red;*/
          /*color: #53A9D7;*/
          color: @blueBG;
          border-color: #E8EDEE;
          font-weight: bold;
          height: 32px;
          z-index: 1900!important;
          &::before {
            content: '';
            background: @blueBG;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
          }
        }
      }
    }
    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 100;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);
      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;
        &:hover {
          background: #eee;
        }
      }
    }
  }
  </style>
  
  <style rel="stylesheet/scss" lang="less">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        margin-top: 3px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        line-height: 10px;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;
        &:before {
          transform: scale(.6);
          display: inline-block;
          vertical-align: -3px;
        }
        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
  </style>
  